import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-n-list',
  templateUrl: './n-list.component.html',
  styleUrls: ['./n-list.component.scss']
})
export class NListComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
